import PropTypes from "prop-types";
import { memo, useCallback, useState } from "react";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { FormattedMessage } from "react-intl";
import Button from "app/pages/.shared/form/Button";
import "./InteractiveMap.scss";

const InteractiveMap = ({ url, thumbnail }) => {
	const { track } = useAnalytics();
	const [isGoogleMapOpen, showGoogleMap] = useState(false);

	const handleMapSkeletonClick = useCallback(() => {
		showGoogleMap(true);
		track("productpage_click_interactive_map");
	}, []);

	if (!url) {
		return false;
	}

	return (
		<div
			className="interactive-map"
			style={{
				background: `url(${thumbnail}) no-repeat center`,
			}}
			data-testid="interactive-map"
		>
			{isGoogleMapOpen ? (
				<iframe
					src={url}
					allow="geolocation"
					allowFullScreen
					data-testid="interactive-map-iframe"
				/>
			) : (
				<div className="interactive-map__note">
					<div className="interactive-map__message">
						<FormattedMessage id="product.page.map.interact" />
						<div className="interactive-map__button">
							<Button variant="primary" onClick={handleMapSkeletonClick}>
								<FormattedMessage id="product.page.map.interactive.button.label.long" />
							</Button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

InteractiveMap.propTypes = {
	url: PropTypes.string,
	thumbnail: PropTypes.string,
};

export default memo(InteractiveMap);
